import React, { useState } from "react";
import {
  Stack,
  TextField,
  InputLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useTheme } from "@mui/material/styles";
// import { useStyles } from "./inputs";
import { InputValidatePropType } from "../../interface/input";
import { ValidationItem } from "./validations";
import { labelSty, styInput } from "./styles-input";
import { StyledIconButton, StyledTextField } from "./inputs";

const InputPassword: React.FC<InputValidatePropType> = ({
  errors,
  register,
  placeholder,
  labelText,
}) => {
  // const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [validations, setValidations] = useState({
    length: false,
    number: false,
    specialChar: false,
    upperLowerCase: false,
  });

  const theme = useTheme();

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newPassword = event.target.value;
    setPassword(newPassword);
    setValidations({
      length: newPassword.length >= 6,
      number: /\d/.test(newPassword),
      specialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(newPassword),
      upperLowerCase: /[a-z]/.test(newPassword) && /[A-Z]/.test(newPassword),
    });
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{labelText}</InputLabel>
      <StyledTextField
        error={!!errors.password}
        helperText={errors.password ? errors.password.message : ""}
        {...register("password")}
        value={password}
        // className={classes.customInput}
        onChange={handlePasswordChange}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <StyledIconButton onClick={handleTogglePassword}>
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </StyledIconButton>
            </InputAdornment>
          ),
          inputProps: {
            style: styInput
          },
        }}
      />
      <Stack direction="column" spacing={2} mt={3}>
        <ValidationItem
          isValid={validations.length}
          text="Must be more than 6 characters"
        />
        <ValidationItem isValid={validations.number} text="Contain a number" />
        <ValidationItem
          isValid={validations.specialChar}
          text="Contain a special character"
        />
        <ValidationItem
          isValid={validations.upperLowerCase}
          text="Contain Upper & lower case letters"
        />
      </Stack>
    </Stack>
  );
};

export default InputPassword;
